import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { renderTableTitle } from "@/utils/render.jsx";
import OverflowTooltipText from "@/components/Common/overflow-tooltip-text.vue";
import { getDownstreamAccountsPage, getDownstreamAlertCandidates, manualBindDownstreamAlert, repushDownstreamAccounts } from "@/service/sync-manage";
import { emptyTableResponse, formatTime, joinNames, selectedSystems, tableFirstResult } from "./sync-utils";
const DEFAULT_ACCOUNT_SYSTEMS = ["UC", "IHOTEL", "ICATER"];
const ACCOUNT_TABLE_BOTTOM_GAP = 16;
const UNIT_CODE_NOT_MATCHED_MESSAGE = "UNIT_CODE_NOT_MATCHED";
const MULTIPLE_MATCHED_MESSAGE = "MULTIPLE_MATCHED";
const DEFAULT_ACCOUNT_FILTERS = {
  downstreamSystem: "ALL",
  statusScope: "ALL",
  search: ""
};
export default {
  name: "sync-accounts-tab",
  components: {
    OverflowTooltipText
  },
  props: {
    appId: {
      type: String,
      default: ""
    },
    unitCode: {
      type: String,
      default: ""
    },
    downstreamOptions: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      filters: {
        ...DEFAULT_ACCOUNT_FILTERS
      },
      tableRows: [],
      accountStats: {},
      statusCounts: {
        SYNCED: null,
        UNSYNCED: null,
        ALERT: null
      },
      badgeRequestId: 0,
      retryModal: {
        visible: false,
        saving: false,
        row: null,
        systems: [],
        systemOptions: []
      },
      candidateModal: {
        visible: false,
        saving: false,
        row: null,
        candidates: [],
        selectedKey: ""
      },
      actionFlow: {
        row: null,
        steps: [],
        dirty: false
      },
      tableHeightValue: Math.max(window.innerHeight - 500, 360),
      tableHeightAdjusting: false
    };
  },
  computed: {
    statusTabs() {
      return [{
        label: $t("avc2x44", "全部成员"),
        value: "ALL",
        count: 0
      }, {
        label: $t("e698r3", "已同步"),
        value: "SYNCED",
        count: this.statNumber(["syncedCount", "successCount"])
      }, {
        label: $t("fiv7n3", "未同步"),
        value: "UNSYNCED",
        count: this.statusBadgeCount("UNSYNCED"),
        type: "warning"
      }, {
        label: $t("b1sq7h4", "同步失败"),
        value: "ALERT",
        count: this.statusBadgeCount("ALERT"),
        type: "danger"
      }];
    },
    // 账号清单业务系统筛选固定展示三套下游，避免当前列表暂无某系统数据时无法主动筛选。
    accountSystemOptions() {
      return this.orderedSystems([...DEFAULT_ACCOUNT_SYSTEMS, ...this.downstreamOptions.map(item => item.value)]).map(value => ({
        value
      }));
    },
    displaySystems() {
      const rowSystems = this.tableRows.reduce((systems, row) => {
        (row.downstreamAccounts || []).forEach(item => {
          if (item.downstreamSystem) systems.push(item.downstreamSystem);
        });
        return systems;
      }, []);
      const systems = [...DEFAULT_ACCOUNT_SYSTEMS, ...this.downstreamOptions.map(item => item.value), ...rowSystems].filter(Boolean);
      return [...new Set(systems)];
    },
    tableConfig() {
      return {
        autoFetch: false,
        columns: this.columns,
        map: {
          dataPath: "retVal.datas",
          message: "msg",
          totalPath: "retVal.totalRows"
        },
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        request: this.queryAccounts,
        table: {
          border: false,
          draggable: false,
          height: this.tableHeight,
          "row-class-name": this.rowClassName
        },
        page: {
          "show-elevator": false,
          "show-sizer": true
        },
        hide: {
          search: true,
          toolBar: true
        }
      };
    },
    tableHeight() {
      return this.tableHeightValue;
    },
    candidateWarningText() {
      const row = this.candidateModal.row || {};
      const downstreamSystem = row._downstreamSystem || row.downstreamSystem;
      return $t("mwzkz73u", "${this.shortSystemName(downstreamSystem)} \u4E2D\u5B58\u5728 ${this.candidateModal.candidates.length} \u4E2A\u540C\u540D\u8D26\u53F7\u300C${row.userName || \"\u2014\"}\u300D\uFF0C\u65E0\u6CD5\u81EA\u52A8\u552F\u4E00\u786E\u5B9A\uFF0C\u8BF7\u9009\u62E9\u6B63\u786E\u8D26\u53F7\u8FDB\u884C\u5173\u8054\u3002", {
        "this.shortSystemName(downstreamSystem)": this.shortSystemName(downstreamSystem),
        "this.candidateModal.candidates.length": this.candidateModal.candidates.length,
        "row.userName || \"\u2014\"": row.userName || "—"
      });
    },
    columns() {
      const systemColumns = this.displaySystems.flatMap(system => [{
        title: `${this.shortSystemName(system)}${" " + $t('l30kc3', '账号名') + ""}`,
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: `${system}Account`,
        minWidth: 150,
        notShowSearch: true,
        notShowForm: true,
        renderTable: (h, {
          row
        }) => this.accountNameNode(h, this.systemAccount(row, system))
      }, {
        title: `${this.shortSystemName(system)}${" " + $t('k1e32', '状态') + ""}`,
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: `${system}Status`,
        minWidth: 130,
        notShowSearch: true,
        notShowForm: true,
        renderTable: (h, {
          row
        }) => this.accountStatusNode(h, this.systemAccount(row, system))
      }]);
      return [{
        title: $t("fqmy2", "姓名"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "userName",
        minWidth: 150,
        fixed: "left",
        ellipsis: true,
        tooltip: true,
        notShowSearch: true,
        notShowForm: true
      }, {
        title: $t("f6ql714", "用户代码"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "userCode",
        minWidth: 140,
        ellipsis: true,
        tooltip: true,
        notShowSearch: true,
        notShowForm: true
      }, {
        title: $t("pgxs2", "部门"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "departments",
        width: 200,
        notShowSearch: true,
        notShowForm: true,
        renderTable: (h, {
          row
        }) => this.departmentNode(h, row)
      }, ...systemColumns, {
        title: $t("brbas86", "最近同步时间"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "latestSyncTime",
        minWidth: 180,
        notShowSearch: true,
        notShowForm: true
      }, {
        title: $t("hkxb2", "操作"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "action",
        width: 100,
        fixed: "right",
        align: "center",
        notShowSearch: true,
        notShowForm: true,
        renderTable: (h, {
          row
        }) => this.renderActions(h, row)
      }];
    }
  },
  mounted() {
    this.updateTableHeight();
    window.addEventListener("resize", this.updateTableHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableHeight);
  },
  methods: {
    resetFilters() {
      this.filters = {
        ...DEFAULT_ACCOUNT_FILTERS
      };
    },
    // 搜索重置需要同时恢复顶部筛选默认值并刷新列表，确保按钮行为和页面初始进入时一致。
    resetSearch() {
      this.resetFilters();
      this.searchTable();
    },
    refresh(reset = false) {
      return new Promise(resolve => {
        this.$nextTick(() => {
          this.updateTableHeight();
          const table = this.$refs.proTable;
          if (table) {
            reset && table.searchAction ? table.searchAction() : table.fetch();
          }
          resolve();
        });
      });
    },
    // 根据当前 Tab 可视区域反推表格高度，保证账号清单卡片底部只保留 16px。
    updateTableHeight() {
      if (this.tableHeightAdjusting) return;
      this.tableHeightAdjusting = true;
      this.$nextTick(() => {
        const panel = this.$el;
        const card = panel === null || panel === void 0 ? void 0 : panel.querySelector(".accounts-card");
        const panelRect = panel === null || panel === void 0 ? void 0 : panel.getBoundingClientRect();
        const cardRect = card === null || card === void 0 ? void 0 : card.getBoundingClientRect();
        if (panelRect !== null && panelRect !== void 0 && panelRect.height && cardRect !== null && cardRect !== void 0 && cardRect.height) {
          const currentGap = panelRect.bottom - cardRect.bottom;
          const nextHeight = Math.max(this.tableHeightValue + currentGap - ACCOUNT_TABLE_BOTTOM_GAP, 300);
          if (Math.abs(nextHeight - this.tableHeightValue) > 1) {
            this.tableHeightValue = nextHeight;
          }
        }
        this.$nextTick(() => {
          this.tableHeightAdjusting = false;
        });
      });
    },
    searchTable() {
      this.refresh(true);
    },
    // 顶部状态页签只改变服务端筛选条件，不在前端本地筛选分页数据。
    selectStatusScope(scope) {
      this.filters.statusScope = scope;
      this.searchTable();
    },
    // 账号清单查询严格使用文档分页接口，页面打开不触发任何重试副作用。
    async queryAccounts(search = {}) {
      if (!this.unitCode) {
        this.tableRows = [];
        return emptyTableResponse();
      }
      const badgeCountsPromise = this.refreshStatusBadgeCounts();
      const {
        data
      } = await getDownstreamAccountsPage(this.accountQueryPayload(search));
      if ((data === null || data === void 0 ? void 0 : data.result) === 0) {
        const retVal = data.retVal || {};
        const rows = this.normalizeAccountRows(retVal.datas || []);
        data.retVal = {
          ...retVal,
          datas: rows
        };
        this.tableRows = rows;
        this.accountStats = data.retVal;
        this.updateStatusCounts(retVal);
      }
      await badgeCountsPromise;
      return data;
    },
    accountQueryPayload(search = {}, overrides = {}) {
      return {
        appId: this.appId,
        unitCode: this.unitCode,
        downstreamSystems: selectedSystems(this.filters.downstreamSystem),
        relationStatus: this.queryRelationStatus(),
        syncStatus: this.querySyncStatus(),
        search: this.filters.search,
        firstResult: tableFirstResult(search),
        pageSize: search.pageSize || 10,
        ...overrides
      };
    },
    // 账号状态角标用独立列表查询取 totalRows，避免当前 tab 列表统计覆盖另一个 tab 角标。
    async refreshStatusBadgeCounts() {
      const requestId = ++this.badgeRequestId;
      const badgeQueries = [{
        type: "UNSYNCED",
        syncStatus: "NONE"
      }, {
        type: "ALERT",
        syncStatus: "FAILED"
      }];
      const responses = await Promise.allSettled(badgeQueries.map(item => getDownstreamAccountsPage(this.accountQueryPayload({
        current: 0,
        pageSize: 1
      }, {
        relationStatus: "ALL",
        syncStatus: item.syncStatus,
        firstResult: 0,
        pageSize: 1
      }), {
        headers: {
          nomsg: true
        }
      })));
      if (requestId !== this.badgeRequestId) return;
      responses.forEach((response, index) => {
        var _data$retVal;
        if (response.status !== "fulfilled") return;
        const {
          data
        } = response.value || {};
        if ((data === null || data === void 0 ? void 0 : data.result) !== 0) return;
        this.$set(this.statusCounts, badgeQueries[index].type, Number((_data$retVal = data.retVal) === null || _data$retVal === void 0 ? void 0 : _data$retVal.totalRows) || 0);
      });
    },
    // 将下游账号数组平铺为表格字段，账号单元格再按原始账号对象补充绑定来源展示。
    normalizeAccountRows(rows = []) {
      const systems = [...DEFAULT_ACCOUNT_SYSTEMS, ...this.downstreamOptions.map(item => item.value), ...rows.reduce((list, row) => {
        (row.downstreamAccounts || []).forEach(account => {
          if (account.downstreamSystem) list.push(account.downstreamSystem);
        });
        return list;
      }, [])].filter(Boolean);
      const uniqueSystems = [...new Set(systems)];
      return rows.map(row => {
        const normalized = {
          ...row,
          userName: row.userName || "—",
          userCode: row.userCode || "—"
        };
        uniqueSystems.forEach(system => {
          normalized[`${system}Account`] = this.systemAccountCode(row, system);
        });
        return normalized;
      });
    },
    queryRelationStatus() {
      if (this.filters.statusScope === "SYNCED") return "BOUND";
      return "ALL";
    },
    querySyncStatus() {
      const statusMap = {
        SYNCED: "SUCCESS",
        UNSYNCED: "NONE",
        ALERT: "FAILED"
      };
      return statusMap[this.filters.statusScope] || "ALL";
    },
    statNumber(fields) {
      for (const field of fields) {
        const value = Number(this.accountStats[field]);
        if (Number.isFinite(value) && value > 0) return value;
      }
      return 0;
    },
    statSum(fields) {
      const total = fields.reduce((sum, field) => {
        const value = Number(this.accountStats[field]);
        return Number.isFinite(value) ? sum + value : sum;
      }, 0);
      return total > 0 ? total : 0;
    },
    firstFiniteNumber(source, fields) {
      for (const field of fields) {
        if (source[field] !== undefined && source[field] !== null) {
          const value = Number(source[field]);
          return Number.isFinite(value) ? value : null;
        }
      }
      return null;
    },
    // 角标计数独立缓存，避免切换到其他状态后用当前列表覆盖未同步/告警数量。
    updateStatusCounts(retVal) {
      const statFieldMap = {
        SYNCED: ["syncedCount", "successCount"],
        UNSYNCED: ["unsyncedCount", "unboundCount", "noneCount"],
        ALERT: ["alertCount", "failedCount", "unackedCount"]
      };
      let updatedCurrentScope = false;
      Object.keys(statFieldMap).forEach(type => {
        if (this.filters.statusScope !== "ALL" && type !== this.filters.statusScope) {
          return;
        }
        const value = this.firstFiniteNumber(retVal, statFieldMap[type]);
        if (value !== null) {
          this.$set(this.statusCounts, type, value);
          if (type === this.filters.statusScope) updatedCurrentScope = true;
        }
      });
      // 非全部页签只允许更新当前页签数量，不能用当前筛选统计覆盖其他角标。
      if (this.filters.statusScope !== "ALL" && !updatedCurrentScope) {
        this.$set(this.statusCounts, this.filters.statusScope, Number(retVal.totalRows) || 0);
      }
    },
    // 角标数量优先取接口统计字段，接口未返回统计时用当前表格数据兜底展示。
    statusBadgeCount(type) {
      const cachedCount = this.statusCounts[type];
      if (Number.isFinite(cachedCount)) return cachedCount;
      if (type === "UNSYNCED") {
        return this.statNumber(["unsyncedCount", "unboundCount", "noneCount"]) || this.fallbackStatusCount(type);
      }
      return this.statNumber(["alertCount"]) || this.statSum(["failedCount", "unackedCount"]) || this.fallbackStatusCount(type);
    },
    fallbackStatusCount(type) {
      return this.tableRows.filter(row => {
        if (type === "UNSYNCED") return this.rowHasUnsyncedInScope(row);
        return this.rowCanRetryInScope(row);
      }).length;
    },
    countScopeSystems() {
      return this.filters.downstreamSystem !== "ALL" ? [this.filters.downstreamSystem] : this.displaySystems;
    },
    rowCanRetryInScope(row) {
      return this.countScopeSystems().some(system => this.isAccountActionable(this.systemAccount(row, system)));
    },
    rowHasUnsyncedInScope(row) {
      return this.countScopeSystems().some(system => {
        const account = this.systemAccount(row, system);
        return (account === null || account === void 0 ? void 0 : account.downstreamSystem) && !this.isAccountSynced(account) && !this.isAccountRetryable(account);
      });
    },
    shortSystemName(system) {
      const names = {
        UC: "UC",
        IHOTEL: "iHotel",
        ICATER: "iCater"
      };
      return names[system] || system;
    },
    businessSystemName(system) {
      const names = {
        UC: $t("f6qc1x4", "用户中心"),
        IHOTEL: "PMS",
        ICATER: $t("jy2n374", "餐饮管理")
      };
      return names[system] || this.shortSystemName(system);
    },
    orderedSystems(systems = []) {
      const order = [...DEFAULT_ACCOUNT_SYSTEMS, ...this.downstreamOptions.map(item => item.value), ...this.displaySystems, ...systems].filter(Boolean);
      const orderMap = [...new Set(order)].reduce((map, system, index) => {
        map[system] = index;
        return map;
      }, {});
      return [...new Set(systems.filter(Boolean))].sort((prev, next) => {
        var _orderMap$prev, _orderMap$next;
        const prevOrder = (_orderMap$prev = orderMap[prev]) !== null && _orderMap$prev !== void 0 ? _orderMap$prev : Number.MAX_SAFE_INTEGER;
        const nextOrder = (_orderMap$next = orderMap[next]) !== null && _orderMap$next !== void 0 ? _orderMap$next : Number.MAX_SAFE_INTEGER;
        if (prevOrder !== nextOrder) return prevOrder - nextOrder;
        return String(prev).localeCompare(String(next));
      });
    },
    accountLastMessage(account) {
      return String((account === null || account === void 0 ? void 0 : account.lastMessage) || "").toUpperCase();
    },
    systemAccount(row, system) {
      return (row.downstreamAccounts || []).find(item => item.downstreamSystem === system);
    },
    systemAccountCode(row, system) {
      const account = this.systemAccount(row, system);
      return (account === null || account === void 0 ? void 0 : account.downstreamUserCode) || (account === null || account === void 0 ? void 0 : account.downstreamUserName) || "—";
    },
    // 下游账号绑定来源统一转换为用户可读文案，未知枚举按来源未知兜底。
    bindingSourceText(bindingSource) {
      const sourceMap = {
        AUTO: $t("gqes0n4", "自动同步"),
        ADMIN_MANUAL: $t("15wfbw5", "管理员绑定"),
        USER_PASSWORD: $t("z6t41f6", "用户密码绑定"),
        UNKNOWN: $t("di6ayu4", "来源未知")
      };
      return sourceMap[bindingSource] || sourceMap.UNKNOWN;
    },
    // 账号名溢出提示保持只展示账号名，绑定来源由右侧信息图标独立展示。
    accountNameNode(h, account) {
      const accountName = (account === null || account === void 0 ? void 0 : account.downstreamUserCode) || (account === null || account === void 0 ? void 0 : account.downstreamUserName) || "—";
      const bound = (account === null || account === void 0 ? void 0 : account.bound) === true;
      const bindingSource = this.bindingSourceText(account === null || account === void 0 ? void 0 : account.bindingSource);
      const accountText = h(OverflowTooltipText, {
        props: {
          text: accountName,
          maxWidth: 320,
          textClass: "account-name-text",
          tooltipClass: "account-name-tooltip",
          tooltipStyle: {
            display: "block",
            flex: "1 1 auto",
            width: "auto",
            minWidth: 0
          }
        }
      });
      if (!bound) return accountText;
      return h("div", {
        class: "account-name-cell"
      }, [accountText, h("Tooltip", {
        class: "account-binding-source-tooltip",
        props: {
          content: bindingSource,
          placement: "top",
          transfer: true
        }
      }, [h("Icon", {
        class: "account-binding-source-icon",
        props: {
          type: "md-information-circle",
          size: 16
        }
      })])]);
    },
    isAccountSynced(account) {
      return account && account.bound && account.lastResult === "SUCCESS" && !account.latestUnacked;
    },
    isAccountRetryable(account) {
      return Boolean(account && (account.latestUnacked || account.lastResult === "FAILED"));
    },
    // 账号清单里的异常既包括普通失败，也包括固定错误码的单位未匹配和多重匹配。
    isAccountActionable(account) {
      const lastMessage = this.accountLastMessage(account);
      return lastMessage === UNIT_CODE_NOT_MATCHED_MESSAGE || lastMessage === MULTIPLE_MATCHED_MESSAGE || this.isAccountRetryable(account);
    },
    rowCanRetry(row) {
      return (row.downstreamAccounts || []).some(account => this.isAccountActionable(account));
    },
    rowHasUnsynced(row) {
      return (row.downstreamAccounts || []).some(account => (account === null || account === void 0 ? void 0 : account.downstreamSystem) && !this.isAccountSynced(account) && !this.isAccountRetryable(account));
    },
    rowClassName(row) {
      if (this.rowCanRetry(row)) return "sync-account-row-alert";
      if (this.rowHasUnsynced(row)) return "sync-account-row-unsynced";
      return "";
    },
    latestSyncTime(row) {
      const times = (row.downstreamAccounts || []).reduce((list, account) => {
        if (account.lastAckTime) list.push(account.lastAckTime);
        if (account.lastPushTime) list.push(account.lastPushTime);
        return list;
      }, []).sort((prev, next) => new Date(next) - new Date(prev));
      return times[0] || "";
    },
    // 最近同步时间需要展示完整年月日时分秒，和同步日志时间格式保持一致。
    formatFullTime(value) {
      return formatTime(value);
    },
    departmentNode(h, row) {
      const department = joinNames(row.departments);
      if (!department || department === "—") {
        return this.textCell(h, "—", "muted");
      }
      return h(OverflowTooltipText, {
        props: {
          text: department,
          maxWidth: 200,
          textClass: "account-department-text",
          tooltipClass: "account-department-tooltip",
          tooltipStyle: {
            display: "block",
            width: "100%",
            minWidth: 0,
            marginTop: "5px"
          }
        }
      });
    },
    textCell(h, value, type = "") {
      const text = value || "—";
      return h("span", {
        class: ["account-text-cell", type]
      }, text);
    },
    accountStatusNode(h, account) {
      if (!account || !account.downstreamSystem) {
        return this.textCell(h, "—", "muted");
      }
      const synced = this.isAccountSynced(account);
      const failed = account.lastResult === "FAILED";
      const statusType = synced ? "success" : failed ? "failed" : account.latestUnacked ? "warning" : "muted";
      const status = synced ? $t("e698r3", "已同步") : failed ? $t("b1sq7h4", "同步失败") : $t("fiv7n3", "未同步");
      return h(OverflowTooltipText, {
        props: {
          text: status,
          maxWidth: 240,
          textClass: `account-status-tag ${statusType}`,
          tooltipClass: "account-status-tooltip",
          // Tooltip 根节点占满单元格，溢出计算才会随表格列宽变化。
          tooltipStyle: {
            display: "block",
            width: "100%",
            minWidth: 0,
            marginTop: "5px"
          },
          textStyle: {
            // inline-flex 在部分浏览器中只裁切内容而不会绘制省略号；inline-block 可正确触发 text-overflow。
            display: "inline-block",
            width: "auto",
            maxWidth: "100%",
            boxSizing: "border-box",
            verticalAlign: "middle"
          }
        }
      });
    },
    lastSyncNode(h, row) {
      const failed = this.rowCanRetry(row);
      return h("span", {
        class: ["account-last-sync", failed ? "failed" : ""]
      }, failed ? $t("fy1g2", "失败") : this.formatFullTime(this.latestSyncTime(row)));
    },
    renderActions(h, row) {
      if (!this.rowCanRetry(row)) {
        return this.textCell(h, "—", "muted");
      }
      return h("button", {
        "class": "account-retry-btn",
        "on": {
          "click": event => {
            event.stopPropagation();
            this.openAccountActionFlow(row);
          }
        }
      }, [h("icon", {
        "class": "account-action-icon",
        "attrs": {
          "type": "ios-build-outline",
          "size": 18,
          "title": $t("pkfc2", "重试")
        }
      })]);
    },
    // 同一成员可能同时存在单位未匹配和多重匹配；这里先聚合一次重推系统，再保留多重匹配系统顺序待后续逐个处理。
    rowActionPlan(row) {
      const repushSystems = [];
      const candidateSystems = [];
      ((row === null || row === void 0 ? void 0 : row.downstreamAccounts) || []).forEach(account => {
        const downstreamSystem = account === null || account === void 0 ? void 0 : account.downstreamSystem;
        if (!downstreamSystem) return;
        const lastMessage = this.accountLastMessage(account);
        if (lastMessage === MULTIPLE_MATCHED_MESSAGE) {
          candidateSystems.push(downstreamSystem);
          return;
        }
        if (lastMessage === UNIT_CODE_NOT_MATCHED_MESSAGE || this.isAccountRetryable(account)) {
          repushSystems.push(downstreamSystem);
        }
      });
      return {
        repushSystems: this.orderedSystems(repushSystems),
        candidateSystems: this.orderedSystems(candidateSystems)
      };
    },
    resetActionFlow() {
      this.actionFlow = {
        row: null,
        steps: [],
        dirty: false
      };
    },
    async finalizeActionFlow() {
      const shouldRefresh = this.actionFlow.dirty;
      this.resetActionFlow();
      if (shouldRefresh) {
        await this.refresh();
      }
    },
    async cancelRetryFlow() {
      this.retryModal.visible = false;
      await this.finalizeActionFlow();
    },
    async cancelCandidateFlow() {
      this.candidateModal.visible = false;
      await this.finalizeActionFlow();
    },
    // 串联流程不再固定“先重试后多重匹配”，而是按照业务系统顺序生成弹窗队列。
    buildActionSteps(row) {
      const {
        repushSystems,
        candidateSystems
      } = this.rowActionPlan(row);
      const systemOrder = this.orderedSystems([...DEFAULT_ACCOUNT_SYSTEMS, ...this.downstreamOptions.map(item => item.value), ...this.displaySystems]);
      const orderOf = system => {
        const index = systemOrder.indexOf(system);
        return index === -1 ? Number.MAX_SAFE_INTEGER : index;
      };
      const steps = candidateSystems.map(system => ({
        type: "candidate",
        system,
        order: orderOf(system)
      }));
      if (repushSystems.length) {
        steps.push({
          type: "retry",
          order: Math.min(...repushSystems.map(system => orderOf(system)))
        });
      }
      return steps.sort((prev, next) => prev.order - next.order);
    },
    openAccountActionFlow(row) {
      const steps = this.buildActionSteps(row);
      this.actionFlow = {
        row,
        steps,
        dirty: false
      };
      this.openNextAction();
    },
    // 重试同步弹窗固定展示三个业务系统：仅“已同步成功”与“多重匹配”禁选；
    // 其余未同步、挂起、同步失败（只要不是 MULTIPLE_MATCHED）都允许在本弹窗内直接重试。
    isRetrySystemDisabled(account) {
      if (this.isAccountSynced(account)) return true;
      const lastMessage = this.accountLastMessage(account);
      return lastMessage === MULTIPLE_MATCHED_MESSAGE;
    },
    retrySystemOptions(row) {
      const systems = this.orderedSystems(DEFAULT_ACCOUNT_SYSTEMS);
      return systems.map(system => {
        const account = this.systemAccount(row, system);
        const disabled = this.isRetrySystemDisabled(account);
        return {
          value: system,
          shortName: this.shortSystemName(system),
          businessName: this.businessSystemName(system),
          disabled
        };
      });
    },
    // 存在多个 UNIT_CODE_NOT_MATCHED 时只弹一次重试窗口，并始终展示 UC / iHotel / iCater 三套系统。
    openRetryModal(row) {
      this.retryModal.row = row;
      const options = this.retrySystemOptions(row);
      this.retryModal.systemOptions = options;
      this.retryModal.systems = options.filter(item => !item.disabled).map(item => item.value);
      this.retryModal.visible = true;
    },
    async openNextAction() {
      const {
        row,
        steps
      } = this.actionFlow;
      if (!row || !steps.length) {
        await this.finalizeActionFlow();
        return;
      }
      const [currentStep, ...restSteps] = steps;
      this.actionFlow = {
        ...this.actionFlow,
        steps: restSteps
      };
      if (currentStep.type === "retry") {
        this.openRetryModal(row);
        return;
      }
      const opened = await this.openCandidates(row, currentStep.system);
      if (!opened) {
        await this.finalizeActionFlow();
      }
    },
    candidateKey(item, index) {
      return [item.downstreamUserKey || "", item.downstreamUserCode || "", index].join("__");
    },
    candidateAccountName(item) {
      return item.downstreamUserCode || item.userName || "—";
    },
    candidateDepartmentName(item) {
      return item.departmentName || item.departmentCode || "—";
    },
    // 候选账号创建时间展示完整年月日时分秒，方便逐个系统确认候选人是否一致。
    candidateCreateDate(value) {
      return formatTime(value);
    },
    // 多重匹配必须按单个业务系统依次查询候选账号，避免一次弹窗同时混入多个系统数据。
    async openCandidates(row, downstreamSystem = "") {
      const currentSystem = downstreamSystem || (row === null || row === void 0 ? void 0 : row._downstreamSystem) || (row === null || row === void 0 ? void 0 : row.downstreamSystem);
      if (!currentSystem || !(row !== null && row !== void 0 && row.userCode)) {
        this.$Message.warning($t("t1qqda8", "请先选择下游系统"));
        return false;
      }
      const {
        data: {
          result,
          retVal,
          msg
        }
      } = await getDownstreamAlertCandidates({
        appId: this.appId,
        unitCode: this.unitCode,
        downstreamSystem: currentSystem,
        users: [{
          openId: row.openId,
          userCode: row.userCode
        }]
      });
      if (result === 0) {
        var _retVal$results;
        const resultRow = (retVal === null || retVal === void 0 || (_retVal$results = retVal.results) === null || _retVal$results === void 0 ? void 0 : _retVal$results[0]) || {};
        this.candidateModal = {
          visible: true,
          saving: false,
          row: {
            ...row,
            _downstreamSystem: currentSystem
          },
          candidates: resultRow.candidates || [],
          selectedKey: ""
        };
        return true;
      }
      this.$Message.error((retVal === null || retVal === void 0 ? void 0 : retVal.message) || msg || $t("d1rj434", "操作失败"));
      return false;
    },
    // 账号清单重试弹窗提示统一由前端拼接“系统名 + 提交成功/失败”，避免直接展示后端原始错误文案。
    retrySubmitToast(systemName, success) {
      const actionText = success ? $t("cx7dr74", "提交成功") : $t("cx66zs4", "提交失败");
      return `${systemName}${actionText}`;
    },
    // 重试提交改为逐个系统提示结果，提示里带系统名；无论成功失败都关闭弹窗，并继续后续串联流程。
    async confirmRetry() {
      const selectedSystems = this.retryModal.systems.filter(system => this.retryModal.systemOptions.some(item => item.value === system && !item.disabled));
      if (!selectedSystems.length) {
        this.$Message.warning($t("z8gsk47", "请选择目标系统"));
        return;
      }
      const row = this.retryModal.row;
      if (!(row !== null && row !== void 0 && row.userCode)) return;
      this.retryModal.saving = true;
      try {
        const responses = await Promise.allSettled(selectedSystems.map(downstreamSystem => repushDownstreamAccounts({
          appId: this.appId,
          unitCode: this.unitCode,
          downstreamSystem,
          userCodes: [row.userCode]
        })));
        let hasSuccess = false;
        responses.forEach((response, index) => {
          var _response$reason, _errorData$result;
          const downstreamSystem = selectedSystems[index];
          const systemName = this.shortSystemName(downstreamSystem);
          if (response.status === "fulfilled") {
            var _response$value;
            const resultData = ((_response$value = response.value) === null || _response$value === void 0 ? void 0 : _response$value.data) || {};
            const success = (resultData === null || resultData === void 0 ? void 0 : resultData.result) === 0;
            const message = this.retrySubmitToast(systemName, success);
            const payload = success ? {
              ...resultData,
              retVal: {
                ...(resultData.retVal || {}),
                message
              }
            } : {
              ...resultData,
              retVal: {
                ...(resultData.retVal || {}),
                message
              },
              msg: message
            };
            if (success) {
              hasSuccess = true;
            }
            this.$emit("operation-result", payload);
            return;
          }
          const errorData = ((_response$reason = response.reason) === null || _response$reason === void 0 || (_response$reason = _response$reason.response) === null || _response$reason === void 0 ? void 0 : _response$reason.data) || {};
          const message = this.retrySubmitToast(systemName, false);
          this.$emit("operation-result", {
            result: (_errorData$result = errorData === null || errorData === void 0 ? void 0 : errorData.result) !== null && _errorData$result !== void 0 ? _errorData$result : -1,
            retVal: {
              ...(errorData.retVal || {}),
              message
            },
            msg: message
          });
        });
        this.retryModal.visible = false;
        if (hasSuccess) {
          this.actionFlow = {
            ...this.actionFlow,
            dirty: true
          };
        }
        await this.openNextAction();
      } finally {
        this.retryModal.saving = false;
      }
    },
    // 多重匹配手动选择账号成功后继续处理下一个系统；全部完成后统一刷新一次账号列表。
    async manualBind() {
      const row = this.candidateModal.row;
      const candidate = this.candidateModal.candidates.find((item, index) => this.candidateKey(item, index) === this.candidateModal.selectedKey);
      const downstreamSystem = (row === null || row === void 0 ? void 0 : row._downstreamSystem) || (row === null || row === void 0 ? void 0 : row.downstreamSystem);
      if (!candidate) {
        this.$Message.warning($t("ui2p207", "请选择候选账号"));
        return;
      }
      if (!row || !downstreamSystem) return;
      this.candidateModal.saving = true;
      try {
        const {
          data
        } = await manualBindDownstreamAlert({
          appId: this.appId,
          unitCode: this.unitCode,
          downstreamSystem,
          openId: row.openId,
          userCode: row.userCode,
          downstreamUserKey: candidate.downstreamUserKey,
          downstreamUserCode: candidate.downstreamUserCode
        });
        this.$emit("operation-result", data);
        if ((data === null || data === void 0 ? void 0 : data.result) === 0) {
          this.actionFlow = {
            ...this.actionFlow,
            dirty: true
          };
          this.candidateModal.visible = false;
          await this.openNextAction();
        }
      } finally {
        this.candidateModal.saving = false;
      }
    }
  }
};